import { render, staticRenderFns } from "./BLayoutDetach.vue?vue&type=template&id=03645a81&"
import script from "./BLayoutDetach.vue?vue&type=script&lang=js&"
export * from "./BLayoutDetach.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/transitions/transition-fade.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./BLayoutDetach.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports